export const heroBusinessAdvisoryText = {
  en: {
    small: " ",
    main: "Business Investment Advisory",
  },
  vi: {
    small: " ",
    main: "Tư vấn Đầu tư Doanh nghiệp",
  },
};

export const quoteBusinessAdvisoryText = {
  en: {
    desc: `With our expertise, your investments aren’t just safe—they’re strategically positioned to deliver high returns, helping you grow your business, expand your portfolio, and achieve long-term financial confidence.`,
    cta: "Contact us now",
  },
  vi: {
    desc: `Với chuyên môn của chúng tôi, các khoản đầu tư của bạn không chỉ an toàn mà còn được định hướng chiến lược để tạo ra lợi nhuận bền vững, giúp doanh nghiệp phát triển, mở rộng danh mục đầu tư và xây dựng nền tảng tài chính vững chắc lâu dài.`,
    cta: "Liên hệ ngay",
  },
};

export const BusinessAdvisoryData = {
  en: [
    {
      id: 1,
      title: "Maximize Your ROI. Grow Your Business Smarter.",
      description:
        "Investing in business should never feel like a gamble. Our Business Investment Advisory service helps business owners and investors make informed decisions, reduce risks, and create sustainable growth through strategic investments and measurable returns.",
      list: [],
    },
    {
      id: 2,
      title: "How We Help You Succeed",
      description: "",
      list: [
        "Identify High-ROI Opportunities: We analyse industries, markets, and business models to uncover investments with strong growth potential.",
        "Unlock Hidden Profit Potential: Discover untapped revenue streams, operational improvements, and scalable business opportunities.",
        "Mitigate Investment Risks: Reduce uncertainty through strategic planning, due diligence, and financial analysis.",
        "Tailored Growth Strategies: Receive customised advice aligned with your business goals, vision, and investment capacity.",
        "Optimize Your Capital: Ensure every investment contributes to measurable business growth and stronger profitability.",
        "Build Long-Term Wealth: Create sustainable investment strategies designed for ongoing business expansion and financial stability.",
      ],
    },
    {
      id: 3,
      title: "Start Your Investment Journey",
      description: "",
      list: [
        "With our expertise, your investments are strategically positioned to deliver stronger returns, helping you grow your business, expand opportunities, and build long-term financial confidence.",
      ],
    },
  ],

  vi: [
    {
      id: 1,
      title:
        "Đầu tư thông minh. Tối đa hóa lợi nhuận. Phát triển doanh nghiệp bền vững.",
      description:
        "Đầu tư vào doanh nghiệp không nên là sự may rủi mà phải là chiến lược tăng trưởng rõ ràng. Dịch vụ Tư vấn Đầu tư Doanh nghiệp của chúng tôi giúp chủ doanh nghiệp và nhà đầu tư đưa ra quyết định đúng đắn, giảm thiểu rủi ro và tạo ra tăng trưởng bền vững với hiệu quả đầu tư cao.",
      list: [],
    },
    {
      id: 2,
      title: "Cách chúng tôi giúp bạn thành công",
      description: "",
      list: [
        "Xác định cơ hội đầu tư ROI cao: Phân tích thị trường, ngành nghề và mô hình kinh doanh để tìm ra cơ hội tăng trưởng tiềm năng.",
        "Khai thác tiềm năng lợi nhuận ẩn: Tìm kiếm nguồn doanh thu mới và tối ưu vận hành để gia tăng lợi nhuận.",
        "Giảm thiểu rủi ro đầu tư: Hạn chế rủi ro thông qua thẩm định, phân tích tài chính và lập kế hoạch chiến lược.",
        "Chiến lược tăng trưởng phù hợp: Xây dựng giải pháp đầu tư phù hợp với mục tiêu tài chính và định hướng doanh nghiệp của bạn.",
        "Tối ưu nguồn vốn: Đảm bảo mỗi khoản đầu tư đều tạo ra giá trị và tăng trưởng rõ ràng.",
        "Xây dựng tài sản dài hạn: Hỗ trợ phát triển doanh nghiệp và danh mục đầu tư theo hướng bền vững và ổn định.",
      ],
    },
    {
      id: 3,
      title: "Bắt đầu hành trình đầu tư",
      description: "",
      list: [
        "Với chuyên môn của chúng tôi, các khoản đầu tư của bạn sẽ được định hướng chiến lược để tạo ra lợi nhuận bền vững, giúp doanh nghiệp phát triển mạnh mẽ và xây dựng nền tảng tài chính vững chắc.",
      ],
    },
  ],
};

export const businessAdvisoryCTA = {
  en: {
    text: "Partner with Us Today and start turning your investment decisions into consistent, high-performing results. ",
    button1: "Contact us now →",
  },
  vi: {
    text: "Đồng hành cùng chúng tôi ngay hôm nay để biến các quyết định đầu tư thành kết quả kinh doanh hiệu quả và tăng trưởng lâu dài.",
    button1: "Liên hệ ngay →",
  },
};
